import { media, selectTheme, styled } from '@creditas-ui/react'

const Header = styled.header`
  color: ${selectTheme('colors.neutral.90')};
  min-height: 82px;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;

  ${media.up('7xl')} {
    min-height: 114px;
    padding: 32px 0;
  }
`

export { Header }
